<app-cl-grid [cols]="columns" (selectionChanged)="select($event)" [data]="this.accountService.dataSource.pagedData"
[filterField]="'name'"
[pageSize]="5"
[dataService]="this.accountService"></app-cl-grid>



<jw-modal id="custom-modal-1">
  <app-account-form (statusChanged) = "this.closeModal('custom-modal-1')" [accounID]="activeItem" ></app-account-form>
</jw-modal>